import type { Action } from 'redux'
import type { CollectionGroupRes } from '@/types/api'

const actionTypes = {
  updateCollectionStore: Symbol('updateCollectionStore')
}

export const actions = {
  updateCollectionStore: (payload: Partial<typeof initialState>) => ({
    type: actionTypes.updateCollectionStore,
    payload
  })
}

export const initialState = {
  group: {
    influencers: [],
    lives: [],
    products: [],
    sellers: [],
    videos: []
  } as CollectionGroupRes
}

export default function reducer(
  state = initialState,
  action: Action<symbol> & { payload: Partial<typeof initialState> }
) {
  switch (action.type) {
    case actionTypes.updateCollectionStore: {
      return {
        ...state,
        ...action.payload
      }
    }
    default:
      return state
  }
}
